import { AlertTriangle } from 'lucide-react'
import { Link } from 'react-router-dom'

import type { ReactElement } from 'react'

import { Button } from '@/components/ui/button'
import { useAccountSession } from '@/features/customer-portal/api/account-api'

// Motivos de pendência FINANCEIRA — os únicos em que o login é permitido. Espelha
// `BILLING_DENIALS` do `sign-in-access-guard`: um motivo que entre lá e não aqui faz o cliente
// logar sem nenhum aviso de que está devendo.
const BILLING_REASONS = ['payment_required', 'payment_overdue'] as const

interface BannerCopy {
  title: string
  description: string
}

const COPY: Record<(typeof BILLING_REASONS)[number], BannerCopy> = {
  payment_required: {
    title: 'Seu período de teste acabou',
    description: 'Assine para continuar usando o VantaCMD. Você escolhe entre cartão e Pix.',
  },
  payment_overdue: {
    title: 'Pagamento pendente',
    description: 'Há uma fatura vencida na sua conta. Regularize para voltar a usar o VantaCMD.',
  },
}

// Aviso PERSISTENTE, não bloqueante. Era um modal que cobria o portal inteiro — e o portal é
// exatamente onde se paga e se consultam as faturas, então travá-lo impedia a única ação que
// resolve a pendência. O produto (desktop) continua travado pela política do backend; aqui o
// cliente precisa circular.
export function AccountPaywallBanner(): ReactElement | null {
  const session = useAccountSession()

  const reason = session.data?.reason
  const matched = BILLING_REASONS.find((r) => r === reason)
  if (!matched) return null

  const copy = COPY[matched]

  return (
    <div
      role="alert"
      className="mb-4 flex flex-col gap-3 rounded-xl border border-warning/40 bg-warning/10 p-4 sm:mb-6 sm:flex-row sm:items-center sm:justify-between"
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-warning" aria-hidden />
        <div className="space-y-0.5">
          <p className="text-sm font-semibold text-foreground">{copy.title}</p>
          <p className="text-sm text-muted-foreground">{copy.description}</p>
        </div>
      </div>

      <div className="flex shrink-0 flex-col-reverse gap-2 sm:flex-row sm:items-center">
        <Button asChild variant="outline" className="h-11 w-full sm:h-10 sm:w-auto">
          <Link to="/conta/faturas">Ver faturas</Link>
        </Button>
        {/* Leva para o bloco de assinatura da visão geral: assinar exige nome, documento e
            endereço de cobrança (exigência do gateway), e esse formulário não cabe num banner. */}
        <Button asChild className="h-11 w-full sm:h-10 sm:w-auto">
          <Link to="/conta#assinatura">Assinar</Link>
        </Button>
      </div>
    </div>
  )
}
